export default {
	messages: {
		de: {
			loading: 'Laden...',
			pleaseWait: 'Bitte warten',
		},
		en: {},
	},
};
